import { gql } from "@apollo/client";

export const GET_PRODUCTS_LIST = gql`
  query GetProducts($input: GetProductInput!) {
   getProducts(input: $input) {
      products {
        id
        name
        createdAt
        updatedAt
        createdById
        updatedById
        createdByName
        updatedByName
      }
    totalCount
  }
}`;

export const GET_PLATFORMS_LIST = gql`
  query GetPlatforms($input: GetPlatformInput!) {
    getPlatforms(input: $input) {
      platforms {
        id
        name
        createdAt
        updatedAt
        createdById
        updatedById
        createdByName
        updatedByName
      }
      totalCount
    }
}`;

export const GET_PROJECTS_LIST = gql`    
  query GetProjects($input: GetProjectInput!) {
    getProjects(input: $input) {
      projects {
        id
        name
        createdAt
        updatedAt
        createdById
        updatedById
        createdByName
        updatedByName
      }
      totalCount
    }
}`;

export const GET_VENDORS = gql`
  query GetVendors($input: GetVendorInput!) {
    getVendors(input: $input) {
      vendors {
        id
        name
        description
        capabilities
        createdAt
        updatedAt
        createdById
        updatedById
        createdByName
        updatedByName
    }
    totalCount
  }
}`;

export const GET_VENDOR_ACCOUNTS = gql`
  query GetVendorAccounts($input: GetVendorAccountInput!) {
  getVendorAccounts(input: $input) {
    vendorAccounts {
      id
      vendorId
      vendorName
      productId
      productName
      associatedDomainName
      vendorMetadata
      createdAt
      updatedAt
      createdById
      updatedById
      createdByName
      updatedByName
    }
    totalCount
  }
}`;

export const GET_VENDOR_USERS = gql`
  query GetVendorUsers($input: GetVendorUserInput!) {
  getVendorUsers(input: $input) {
    vendorUsers {
      id
      vendorAccountId
      associatedDomainName
      externalUserId
      userType
      roleName
      firstName
      lastName
      email
      userMetadata
      capabilities
      isUsed
      isActive
      createdAt
      updatedAt
      createdById
      updatedById
      createdByName
      updatedByName
    }
    totalCount
  }
}`;

export const GET_VENDOR_PROJECT_USERS = gql`
  query GetVendorProjectUsers($input: GetVendorProjectUserInput!) {
  getVendorProjectUsers(input: $input) {
    vendorProjectUsers {
      id
      projectId
      projectName
      vendorUserId
      vendorUserName
      vendorEmail
      userType
      isUsed
      isActive
      createdAt
      updatedAt
      createdById
      updatedById
      createdByName
      updatedByName
    }
    totalCount
  }
}`;

export const GET_LIVE_SESSIONS = gql`
  query GetLiveSessions($input: GetLiveSessionInput!) {
  getLiveSessions(input: $input) {
    liveSessions {
      id
      vendorId
      vendorName
      vendorAccountId
      vendorAccountName
      projectId
      projectName
      externalSessionId
      sessionType
      status
      scheduledStartTime
      scheduledEndTime
      actualStartTime
      actualEndTime
      sessionMetadata
      createdAt
      updatedAt
      createdById
      updatedById
      createdByName
      updatedByName
    }
    totalCount
  }
}`;

export const GET_TEACHERS = gql`
  query GetTeachers($input: GetTeacherInput!) {
    getTeachers(input: $input) {
      teachers {
      id
      employeeId
      departmentId
      departmentName
      designationId
      designationName
      isArchived
      createdAt
      updatedAt
      createdById
      updatedById
      createdByName
      updatedByName
      employee{
        id
        firstName
        lastName
        email
        employeeId
      }
    }
    totalCount
    }
}`;


export const GET_SESSION_ALLOCATIONS = gql`
  query GetSessionAllocations($input: GetSessionAllocationInput!) {
    getSessionAllocations(input: $input) {
      sessionAllocations {
        id
        projectId
        liveSessionId
        vendorUserId
        userType
        allocationStatus
        entityType
        entityId
        entityValue
        entityName
        bufferedStartTime
        bufferedEndTime
        actualStartTime
        actualEndTime
        type
        createdAt
        updatedAt
        createdById
        updatedById
        createdByName
        updatedByName
        liveSession {
          id
          externalSessionId
          sessionType
          status
          scheduledStartTime
          scheduledEndTime
        }
        vendorUser {
          id
          firstName
          lastName
          email
        }
      }
      totalCount
    }
}
`;

export const GET_SESSION_USAGES = gql`
  query GetSessionUsages($input: GetSessionUsageInput!) {
    getSessionUsages(input: $input) {
      sessionUsages {
        id
        projectId
        liveSessionId
        entityType
        entityId
        entityValue
        entityName
        joinedAt
        leftAt
        timeSpentInSeconds
        hasAttended
        attendanceMetadata
        isActive
        createdAt
        updatedAt
        createdById
        updatedById
        createdByName
        updatedByName
        
      }
      totalCount
    }
}
`;

export const GET_NLEARN3_LIVECLASS_PACKAGES = gql`
query GetNlearn3LiveclassPackages($input: GetNlearn3LiveclassPackageInput!) {
  getNlearn3LiveclassPackages(input: $input) {
    nlearn3LiveclassPackages {
      id
      name
      batchId
      batchName
      classId
      className
      collegeId
      collegeName
      sectionId
      sectionName
      academicYearId
      academicYearName
      streamId
      streamName
      packageStudentsCount
      createdAt
      updatedAt
      createdById
      updatedById
      createdByName
      updatedByName
    }
    totalCount
  }
}`;

export const GET_NLEARN3_PACKAGE_SCHEDULES = gql`
query GetNlearn3PackageSchedules($input: GetNlearn3PackageScheduleInput!) {
  getNlearn3PackageSchedules(input: $input) {
    nlearn3PackageSchedules {
      id
      liveSessionId
      status
      scheduledDurationInMin
      scheduledParticipantsCount
      meetingTitle
      meetingSubTitle
      thumbnailUrl
      notesUrl
      recordingMetadata
      cancelledAt
      completedAt
      isActive
      createdAt
      updatedAt
      createdById
      updatedById
      createdByName
      updatedByName
      employeeDepartmentId
      employeeDepartmentName
      employeeDesignationId
      employeeDesignationName
      nlearn3LiveclassPackages {
        id
        name
        batchId
        batchName
        classId
        className
        collegeId
        collegeName
        sectionId
        sectionName
        academicYearId
        academicYearName
        streamId
        streamName
      }
      liveSession {
        id
        vendorId
        vendorName
        vendorAccountId
        vendorAccountName
        projectId
        projectName
        externalSessionId
        sessionType
        status
        scheduledStartTime
        scheduledEndTime
        actualStartTime
        actualEndTime
        sessionMetadata
      }
    }
    totalCount
  }
}`;


export const GET_NLEARN3_LIVECLASS_GROUP_PACKAGE_SUBSCRIBERS = gql`
  query GetNlearn3LiveclassGroupPackageSubscribers($input: GetNlearn3LiveclassGroupPackageSubscriberInput!) {
    getNlearn3LiveclassGroupPackageSubscribers(input: $input) {
      nlearn3LiveclassGroupPackageSubscribers {
        id
        nlearn3LiveclassPackageId
        entityId
        isArchived
        createdAt
        updatedAt
        createdById
        updatedById
        createdByName
        updatedByName
        admissionNumber
        nlearn3LiveclassPackage {
          id
          name
          batchId
          batchName
          classId
          className
          collegeId
          collegeName
          sectionId
          sectionName
          academicYearId
          academicYearName
          streamId
          streamName
        }
      }
      totalCount
    }
}`;

export const GET_EMPLOYEE_DEPARTMENTS = gql`
  query GetEmployeeDepartments($input: GetEmployeeDepartmentInput!) {
    getEmployeeDepartments(input: $input) {
      employeeDepartments {
        id
        name
        description
        isTeaching
        isLanguage
        createdAt
        updatedAt
        createdById
        updatedById
        createdByName
        updatedByName
      }
      totalCount
    }
}`;

export const GET_EMPLOYEE_DESIGNATIONS = gql`
  query GetEmployeeDesignations($input: GetEmployeeDesignationInput!) {
    getEmployeeDesignations(input: $input) {
      employeeDesignations {
        id
        name
        description
        createdAt
        updatedAt
        createdById
        updatedById
        createdByName
        updatedByName
      }
      totalCount
    }
}`;

export const GET_NLEARN3_ACADEMIC_YEARS = gql`
  query GetNlearn3AcademicYears($input: GetNlearn3AcademicYearInput!) {
    getNlearn3AcademicYears(input: $input) {
      nlearn3AcademicYears {
        objectId
        yearId
        name
        isArchived
      }
      totalCount
    }
}`;

export const GET_NLEARN3_BATCHES = gql`
  query GetNlearn3Batches($input: GetNlearn3BatchInput!) {
    getNlearn3Batches(input: $input) {
      nlearn3Batches {
        objectId
        batchId
        name
        isArchived
      }
      totalCount
    }
}`;

export const GET_NLEARN3_BRANCHES = gql`
  query GetNlearn3Branches($input: GetNlearn3BranchInput!) {
    getNlearn3Branches(input: $input) {
      nlearn3Branches {
        objectId
        name
        collegeId
        isArchived
        
      }
      totalCount
    }
}`;

export const GET_NLEARN3_SECTIONS = gql`
  query GetNlearn3Sections($input: GetNlearn3SectionInput!) {
    getNlearn3Sections(input: $input) {
      nlearn3Sections {
        objectId
        sectionId
        name
      }
      totalCount
    }
}`;

export const GET_NLEARN3_STREAMS = gql`
  query GetNlearn3Streams($input: GetNlearn3StreamInput!) {
    getNlearn3Streams(input: $input) {
      nlearn3Streams {
        objectId
        streamId
        name
      }
      totalCount
    }
}`;

export const GET_NLEARN3_STUDENTS = gql`
  query GetNlearn3Students($input: GetNlearn3StudentInput!) {
    getNlearn3Students(input: $input) {
      nlearn3Students {
        id
        admissionNumber
        studentName
        parentName
        phone
        email
        dob
        gender
        category
      }
      totalCount
    }
}`;

export const GET_NLEARN3_CLASSES = gql`
  query GetNlearn3Classes($input: GetNlearn3ClassInput!) {
    getNlearn3Classes(input: $input) {
      nlearn3Classes {
        objectId
        classId
        name
        isArchived
      }
      totalCount
    }
}`;

export const GET_EMPLOYEES = gql`
query GetEmployees($input: GetEmployeeInput!) {
  getEmployees(input: $input) {
    employees {
      id
      firstName
      lastName
      employeeId
      username
      email
      gender
    }
    totalCount
  }
}`;

export const GET_NLEARN3_LIVECLASS_MASTERS = gql`
query GetNlearn3LiveclassMasters($input: GetNlearn3LiveClassMasterInput!) {
  getLiveclassMasters(input: $input) {
    nlearn3LiveClassMasters {
      id
      class
      liveClassUrl
      recordedUrls
      thumbnail
      urlSource
      name
      duration
      liveDateTime
      courseDay
      batch
      subBatch
      college
      admissionNumber
      markAsDeleted
      liveClassId
      subjectName
      subject
      employee
      branch
      department
      designation
      recordedVideoMaxVisibleDate
      packageId
      packageName
      yearId
      createdAt
      updatedAt
    }
    totalCount
  }
}`